export default __webpack_public_path__ + "static/media/google-play.9792e090.png";